import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

export const TopActionsProgressCardSkeleton = () => {
  return (
    <Table sx={{ mt: 1 }}>
      <TableHead sx={{ background: "transparent", boxShadow: "none" }}>
        <TableRow
          sx={{
            "&:hover": { backgroundColor: "transparent" },
            "& th": {
              py: "0 !important",
            },
          }}
        >
          <TableCell
            sx={{
              borderBottom: "none",
              background: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              pl: 0,
              width: "40%",
            }}
          >
            <Skeleton
              variant="text"
              width={100}
              height={24}
              animation="wave"
              sx={{ backgroundColor: "grey.400" }}
            />
          </TableCell>
          <TableCell
            sx={{
              borderBottom: "none",
              background: "transparent",
              pl: 0,
              width: "20%",
            }}
          >
            <Skeleton
              variant="text"
              height={24}
              width={120}
              animation="wave"
              sx={{ backgroundColor: "grey.400" }}
            />
          </TableCell>
          <TableCell
            sx={{
              borderBottom: "none",
              background: "transparent",
              pl: 0,
              width: "16%",
            }}
          >
            <Skeleton
              variant="text"
              height={24}
              width={80}
              animation="wave"
              sx={{ backgroundColor: "grey.400" }}
            />
          </TableCell>
          <TableCell
            sx={{
              borderBottom: "none",
              background: "transparent",
              pl: 0,
              width: "10%",
            }}
          >
            <Skeleton
              variant="text"
              height={24}
              width={60}
              animation="wave"
              sx={{ backgroundColor: "grey.400" }}
            />
          </TableCell>
          <TableCell
            sx={{
              borderBottom: "none",
              background: "transparent",
              pl: 0,
              width: "15%",
            }}
          >
            <Skeleton
              variant="text"
              height={24}
              width={80}
              animation="wave"
              sx={{ backgroundColor: "grey.400" }}
            />
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody sx={{ "& td": { pl: 0, py: 1, borderBottom: "none" } }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <TableRow
            key={i}
            sx={{ ":hover": { backgroundColor: "transparent" } }}
          >
            <TableCell width={"40%"}>
              <Skeleton variant="rectangular" height={24} animation="wave" />
            </TableCell>
            <TableCell width={"25%"}>
              <Skeleton
                variant="rectangular"
                height={30}
                animation="wave"
                sx={{ borderRadius: 1 }}
              />
            </TableCell>
            <TableCell width="10%">
              <Skeleton
                variant="rectangular"
                height={30}
                animation="wave"
                sx={{ borderRadius: 1 }}
              />
            </TableCell>
            <TableCell width="10%">
              <Skeleton
                variant="rectangular"
                height={30}
                sx={{ borderRadius: 1 }}
                animation="wave"
              />
            </TableCell>
            <TableCell width="10%">
              <Skeleton
                variant="rectangular"
                height={30}
                sx={{ borderRadius: 1 }}
                animation="wave"
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
